import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=15378612&"
import script from "./verify-email.vue?vue&type=script&lang=ts&"
export * from "./verify-email.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports